import React from "react";
import { EntityComplaint } from "types/EntityComplaint";
import NavigationButton from "../NavigationButton/NavigationButton";
import ComparerIndicator from "../ComparerIndicator/ComparerIndicator";
import { SlArrowLeft } from "react-icons/sl";
import { ActiveComponentEnum } from "enums/enums";
import { OnNavigateFunction } from "types/ListAndDetailTypes";
import Const from "const.json";
import { numberWithCommas } from "utils/utils";

const idOrderDictonary = {
  1: "1", 2: "2", 3: "4", 4: "3", 5: "5", 6: "6", 7: "7"
}

const District: React.FC<{
  district: EntityComplaint;
  onNavigate: OnNavigateFunction;
}> = ({ district, onNavigate }) => {

  const complaintsCount = numberWithCommas(district.complaintsCount)
  return (
    <div className={`district district-${district.id} `} style={{ order: idOrderDictonary[district.id] }}>
      <h5 className=" line-container fs-7 bold">{district.description}
        <div className="line"></div>
      </h5>
      <h4 className="bold m-0">
        {complaintsCount} {Const.complaints}
      </h4>
      <ComparerIndicator
        comparerData={district.comparerData}
        additionalText={Const.thePreviousYear}
      />
      <div>
        <NavigationButton
          ariaLabelText={district.description}
          navigateTo={ActiveComponentEnum.EntityDetails}
          text={Const.forExpansion}
          icon={<SlArrowLeft />}
          iconLabel={Const.leftIcon}
          additionalParams={district}
          onNavigate={onNavigate}
        />
      </div>
    </div>
  );
};

export default District;
